import { render } from "./CollectionResurrectList.vue?vue&type=template&id=2b2a9e36"
import script from "./CollectionResurrectList.vue?vue&type=script&lang=js"
export * from "./CollectionResurrectList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__